import { createContext, useContext } from 'react';

export type ThemeMode = 'light' | 'dark' | 'system';
export type ResolvedTheme = 'light' | 'dark';

/**
 * Light or dark, and nothing else.
 *
 * The product carries a second axis here — the brand palette a customer picks —
 * and the console deliberately does not: it is one internal tool with one
 * audience, and a hue rotation on the chrome of an audit trail answers no
 * question anybody asked. The mode is kept because it is read at the time of
 * day someone is on call.
 */
export interface ThemeContextValue {
  theme: ThemeMode;
  resolvedTheme: ResolvedTheme;
  setTheme: (theme: ThemeMode) => void;
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);

export function useTheme(): ThemeContextValue {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used inside ThemeProvider');
  }
  return context;
}
